var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-coin-input" }, [
    _c(
      "div",
      {
        staticClass:
          "v-input v-text-field v-input--has-state v-input--is-label-active v-input--is-dirty theme--light",
        class: {
          "v-input--is-focused": _vm.focused,
          "secondary--text": _vm.focused,
          "error--text": _vm.hasError,
          "v-input--is-disabled": _vm.disabled,
        },
      },
      [
        _c("div", { staticClass: "v-input__control" }, [
          _c("div", { staticClass: "v-input__slot" }, [
            _c(
              "div",
              { staticClass: "v-text-field__slot" },
              [
                _c(
                  "label",
                  {
                    staticClass: "v-label v-label--active theme--light",
                    class: {
                      "required-field": _vm.isRequired && !_vm.hideRequired,
                      "secondary--text": _vm.focused,
                      "error--text": _vm.hasError,
                    },
                    attrs: { "aria-hidden": "true" },
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.label) + "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "money",
                  _vm._b(
                    {
                      attrs: { value: _vm.value, disabled: _vm.disabled },
                      on: { input: _vm.input },
                      nativeOn: {
                        blur: function ($event) {
                          return _vm.blur.apply(null, arguments)
                        },
                        focus: function ($event) {
                          return _vm.focus.apply(null, arguments)
                        },
                        keydown: function ($event) {
                          return _vm.keydown.apply(null, arguments)
                        },
                        focusout: function ($event) {
                          return _vm.focusout.apply(null, arguments)
                        },
                      },
                    },
                    "money",
                    _vm.config,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.currentError
            ? _c("div", { staticClass: "v-text-field__details" }, [
                _c(
                  "div",
                  {
                    staticClass: "v-messages theme--light",
                    class: { "error--text": _vm.hasError },
                  },
                  [
                    _c("div", { staticClass: "v-messages__wrapper" }, [
                      _c("div", { staticClass: "v-messages__message" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.currentError) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }